import React from 'react';
import { LoadScript } from '@react-google-maps/api';

const GoogleMapsProvider = ({ children }) => {
    const apiKey = `${process.env.REACT_APP_API_KEY_GOOGLE}`;

    return (
        <LoadScript googleMapsApiKey={apiKey}>
            {children}
        </LoadScript>
    );
};

export default GoogleMapsProvider;
